import * as THREE from "three";

export default class HoverAnimator {

    constructor(scene, timeScale = 1) {
        this._timeScale = timeScale;

        this._clock = new THREE.Clock();
        this._mixer = new THREE.AnimationMixer(scene);

        this._hoverAnimations = new Map();

        this._prevClosest = null;

        this._handleHover = this._handleHover.bind(this);
    }

    observe(observer) {
        this._observer = observer;
        for (const object of this._hoverAnimations.keys()) {
            this._observer.addObject(object);
        }
        this._observer.addListener(this._handleHover);
    }

    addObject(object, animation) {
        const action = this._mixer.clipAction(animation);
        action.setLoop(THREE.LoopOnce);
        action.clampWhenFinished = true;
        action.timeScale = 0;
        action.play();

        this._hoverAnimations.set(object, action);
        this._observer?.addObject(object);
    }

    update() {
        this._mixer.update(this._clock.getDelta());
    }

    _animateForwards(object) {
        const a = this._hoverAnimations.get(object);
        if (a) {
            a.timeScale = this._timeScale;
            a.paused = false;
        }
    }

    _animateBackwards(object) {
        const a = this._hoverAnimations.get(object);
        if (a) {
            a.timeScale = -this._timeScale;
            a.paused = false;
        }
    }

    _handleHover(closest) {
        if (closest !== this._prevClosest) {
            if (closest !== null) {
                this._animateForwards(closest);
            }

            if (this._prevClosest !== null) {
                this._animateBackwards(this._prevClosest);
            }

            this._prevClosest = closest;
        }
    }

}
